






















































































































/* eslint-disable */
import { Component, Watch, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import moment from 'moment'
import Timezone from 'moment-timezone'
import { NumberMixin, DateMixin, ProvisaoMixin } from '@finx/web-repository/src/mixin/_'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { APROVAR_MUT_DATA_INICIAL, APROVAR_MUT_DATA_FINAL, APROVAR_DIS_LISTAR } from '@/store/medico/provisao/aprovar-const'
import AprovarStore from '@/store/medico/provisao/aprovar'
import Provisao from '@/store/Provisao'

@Component({
  store: AprovarStore,
  mixins: [NumberMixin, DateMixin],
})

export default class ViewProvisaoAprovar extends Vue {
  loading: any = {
    status: true,
    text: 'Carregando...',
  }

  disableAproveProvisao: Boolean = false
  usuario: any = {}

  get agrupamento() {
    return this.$store.getters.resultado
  }

  created() {
    if (this.$store.state.dataInicial == null) {
      const dataInicial = moment().add(-5, 'years').toDate()
      dataInicial.setHours(0)
      dataInicial.setMinutes(0)
      dataInicial.setSeconds(0)
      dataInicial.setMilliseconds(0)

      const dataFinal = moment().toDate()
      dataFinal.setHours(23)
      dataFinal.setMinutes(59)
      dataFinal.setSeconds(59)
      dataFinal.setMilliseconds(999)

      // @ts-ignore
      this.$store.commit(APROVAR_MUT_DATA_INICIAL, this.tranformDate2Epoch(dataInicial,))
      // @ts-ignore
      this.$store.commit(APROVAR_MUT_DATA_FINAL, this.tranformDate2Epoch(dataFinal,))
    }

    this.$store.dispatch(APROVAR_DIS_LISTAR)
  }

  mounted() {
    this.getUsuario()
  }

  @Watch('agrupamento')
  onAgrupamentoChange() {
    if (this.agrupamento) {
      this.loading.status = false
    }
  }

  formatarDataRealizacao(data) {
    return moment(data).locale('pt-br').format('DD/MMM').toUpperCase()
  }

  efetivarTodos(id, paciente) {
    this.loading.status = true

    const that = this

    ApiLegacy.Provisao.efetivarProducao(id, null)
      .then((result) => {
        if (result.status === 200) that.$store.dispatch(APROVAR_DIS_LISTAR)
        this.$ga.event('provisao', 'aprovar', this.usuario.email, paciente.quantidadeProcedimentos)
        that.loading.status = false
      })
  }

  async getUsuario() {
    this.usuario = this.$user.profile
  }
}

